<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>New Staff Member</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form 
    [formGroup]='stylistProfileForm' 
    (ngSubmit)="onStylistFormSave()"
    >
    <ion-list>
      <ion-item lines="none">
        <ion-label position="stacked">First Name *</ion-label>
        <ion-input type="text" name='' formControlName="firstName" clearInput></ion-input>
      </ion-item>

      <ion-item *ngIf="!firstName.valid && submitAttempt">
        
        <p *ngIf="firstName.hasError('required')" class='sm-error'>
          First Name is required.
        </p>

        <p *ngIf="firstName.hasError('maxlength')" class='sm-error'>
          First Name cannot exceed 30 characters.
        </p>

      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">Last Name</ion-label>
        <ion-input type="text" name='' formControlName="lastName" clearInput></ion-input>
      </ion-item>

      <ion-item *ngIf="!lastName.valid && submitAttempt" lines="none">    
        <p *ngIf="lastName.hasError('maxlength')" class='sm-error'>
          Last Name cannot exceed 35 characters.
        </p>
      </ion-item>
      <ion-item lines="none">
        <ion-label position="stacked">Pronouns</ion-label>
        <ion-select formControlName="pronouns" [interface]="'popover'">
          <ion-select-option *ngFor="let option of pronounOptions"
          [value]="option.value">
            {{ option.name }}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item lines="none" [hidden]="pronouns.value != 4" >
        <ion-label position="stacked">Enter Custom Pronouns</ion-label>
        <ion-input type="text" name='customPronouns' formControlName="customPronouns" clearInput></ion-input>
      </ion-item>
      <ion-item *ngIf="!customPronouns.valid && submitAttempt">
        <p *ngIf="customPronouns.hasError('maxlength')" class='sm-error'>
            Custom Pronouns can't exceed 30 letters.
        </p>
      </ion-item>
      
      <ion-item lines="none">
        <ion-label position="stacked">Email *</ion-label>
        <ion-input type="email" name='' formControlName="email" clearInput></ion-input>
      </ion-item>

      <ion-item *ngIf='email.pending' lines="none">
        <ion-spinner icon='crescent' color='primary'></ion-spinner>&nbsp;&nbsp;<span>Checking email availability...</span>
      </ion-item>

      <ion-item *ngIf="!email.valid && email.hasError('stylistEmailAvailability')" lines="none">
        <p class='sm-error'>
          Email already taken.
        </p>
      </ion-item>

      <ion-item *ngIf="!email.valid && submitAttempt" lines="none">
        <p *ngIf="email.hasError('required')" class='sm-error'>
          Email is required.
        </p>

        <p *ngIf="email.hasError('validateEmail')" class='sm-error'>
          Email is invalid.
        </p>

        <p *ngIf="email.hasError('maxlength')" class='sm-error'>
          Email cannot exceed 100 characters.
        </p>
      </ion-item>
      
      <ion-item lines="none">
        <ion-label position="stacked">Title</ion-label>
        <ion-input type="text" name='' formControlName="title" clearInput></ion-input>
      </ion-item>
      <ion-item *ngIf="!title.valid && submitAttempt" lines="none">
        <p *ngIf="lastName.hasError('maxlength')" class='sm-error'>
          Title Name cannot exceed 35 characters.
        </p>
      </ion-item>

      <ion-item>
        <ion-label>Active</ion-label>
        <ion-toggle formControlName='active'></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>Administrator</ion-label>
        <ion-toggle formControlName='administrator'></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>Scheduling (has a calendar)</ion-label>
        <ion-toggle formControlName='hasCalendar'></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>Can edit their own settings</ion-label>
        <ion-toggle formControlName='canEditOwnSettings'></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>Can view all clients of the salon</ion-label>
        <ion-toggle formControlName='canViewAllClients'></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>Can view all staff calendars</ion-label>
        <ion-toggle formControlName='canViewAllStaffCalendars'></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>Can view their reports</ion-label>
        <ion-toggle formControlName='canViewAllReports'></ion-toggle>
      </ion-item>
      <ion-item>
        <ion-label>Can receive push notifications</ion-label>
        <ion-toggle formControlName='canReceivePushNotificaitons'></ion-toggle>
      </ion-item>
      
    </ion-list>
    <br />
    <br />
    <br />
  </form>

</ion-content>

<ion-footer class="ion-no-padding">
  <ion-toolbar class="ion-no-padding ion-no-margin">
    <ion-button expand="block" clas="ion-no-margin"  (click)="onStylistFormSave()">Save</ion-button>
  </ion-toolbar>
</ion-footer>
